
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { Transition } from '@uirouter/core';

import { type StatesList } from '@tdwb/webbroker/core';
import { ModalNotificationComponent } from './modal-notification.component';

export class ModalNotificationResolver {

  static resolveTriggerIdParam(transition: Transition): string {
    return transition.params().triggerId;
  }

}

export class ModalNotificationRoutes {
  static states: StatesList = [
    {
      name: 'modal.modal-notification',
      url: '/platform/notification/:triggerId',
      params: {
        triggerId: {
          type: 'string'
        },
        triggerLinkId: {
          type: 'string'
        },
        persistence: {
          type: 'string'
        }
      },
      data: {
        modalOptions: {
          component: ModalNotificationComponent
        }
      },
      resolve: [
        {
          token: 'triggerId',
          deps: [Transition],
          resolveFn: ModalNotificationResolver.resolveTriggerIdParam,
          policy: { when: 'EAGER', async: 'WAIT' }
        }
      ]
    }
  ];
}
